import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFieldTableModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  value: any;
  isAutoNumberColumn: boolean;
}

export class FieldTableModel extends BaseFieldModel implements IFieldTableModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public value: any,
    public isAutoNumberColumn: boolean,
  ) {
    super(isRequired, isReadOnly);
  }
}
